module.exports = __webpack_public_path__ + "media/images/talent/case6-icon01-467af83dcfea3ed975b749af2d48f4ac.png";